import { Link } from "react-router-dom";
import "./index.css";
import { useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";

const NotFound = () => {
  const { setActiveRoute } = useContext(AppContext);
  useEffect(() => {
    setActiveRoute("/not-found");
  }, [setActiveRoute]);

  return (
    <div className="notfound-container">
      <img
        src="https://iqteche.in/static/images/404_error_page.png?v=d1b40c2b2b2ccbf2ab233d42ffbe73f6"
        alt="404"
        className="not-found-image"
      />
      <h1 className="notfound-title">404</h1>
      <p className="notfound-message">Oops! Page not found.</p>
      <p className="notfound-message">
        We're unable to find the Page you're looking for.
      </p>
      <Link to="/" className="notfound-btn">
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
